import React from 'react';

import { Divider, ButtonPrimary, Spacer } from '../../../../shared/components';

export default function Footer({ confirmCb, closeCb, enableButtons }) {
  return (
    <div>
      {enableButtons && (
        <>
          <Divider.Horizontal />
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              boxSizing: 'border-box',
              padding: '10px',
            }}
          >
            <ButtonPrimary.Small label="Cancelar" onClick={closeCb} />
            <Spacer.horizontal size={5} />
            <ButtonPrimary.Small label="Confirmar" onClick={confirmCb} />
          </div>
        </>
      )}
    </div>
  );
}
